/* eslint-disable */

import moment from 'moment';
import axios from 'axios';

//axios.defaults.baseURL = 'https://y0gky23tog.execute-api.us-east-1.amazonaws.com/dev';
axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL

export default {

    namespaced: true,
    state: {
        lists: [],
        list: {},
        masterList: [],
    },
    mutations: {

        setLists(state, lists) {
            state.lists = lists
        },

        setList(state, list) {
            state.list = list;
        },

        setMasterList(state, masterList) {
            state.masterList = masterList;
        }

    },
    actions: {
        setLists({commit}, lists) {
            commit('setLists', lists);
        },

        setList({commit}, list) {
            commit('setList', list);
        },

        setMasterList({commit}, masterList) {
            commit('setMasterList', masterList);
        },

        async createList({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});                
                let response = await axios.post('/list', payload, { crossdomain: true });                
                dispatch('alert/setLoaded', true, {root: true});
                if(!payload.ListID)
                    dispatch('alert/setMessage', 'List added successfully!', {root: true});
                else
                    dispatch('alert/setMessage', 'List updated successfully!', {root: true});
                dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
            } catch(err) {
                console.log('Error creating a list:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },

        async deleteList({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});                
                let response = await axios.post('/delete-list', payload, { crossdomain: true });                
                dispatch('alert/setLoaded', true, {root: true});
                dispatch('alert/setMessage', 'List removed successfully!', {root: true});
                dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
            } catch(err) {
                console.log('Error removing a list:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },

        async removePatientFromList({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});        
                let response = await axios.post('/remove-patient-from-list', payload, { crossdomain: true });
                /*
                dispatch('alert/setLoaded', true, {root: true});
                dispatch('alert/setMessage', 'Patient removed from list successfully!', {root: true});
                dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                */
            } catch(err) {
                console.log('Error removing a patient from list:', err);
                throw err;
                /*
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
                */
            }
        },
    }
}